import { Link } from 'react-router-dom';

const LAST_UPDATED = 'February 3, 2026';

export const PrivacyPolicyPage = () => (
  <div className="min-h-screen bg-[#FBF6EC]">
    <div className="max-w-3xl mx-auto px-6 py-14">
      <Link to="/" className="text-[#D95A41] hover:underline text-sm" data-testid="privacy-back-home">
        ← Back to home
      </Link>
      <h1 className="text-4xl font-bold text-[#2A2320] mt-4">Privacy Policy</h1>
      <p className="text-sm text-neutral-600 mt-2">Last updated: {LAST_UPDATED}</p>

      <div className="mt-8 space-y-8 text-[#2A2320] leading-relaxed">
        <p>
          Eat From Local ("we", "our", "us") is a neighbourhood marketplace that helps home cooks
          share meals with people who live nearby. This page explains what information we collect,
          what we <em>don't</em> collect, and how we use what we do have.
        </p>

        <section>
          <h2 className="text-2xl font-bold mb-3">1. Information You Provide</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              <strong>Profile Data:</strong> We collect your name, email, and suburb to help
              neighbours find your food.
            </li>
            <li>
              <strong>Cook Content:</strong> Photos and descriptions of your dishes are public to
              help buyers find you.
            </li>
            <li>
              <strong>Communication:</strong> When you message a cook, that conversation is stored
              so you can coordinate your order. We do <strong>not</strong> see your exact home
              address unless you choose to share it privately in a message.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3">2. No Payment Data</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              <strong>Direct Coordination:</strong> Eat From Local is a marketplace for discovery.
              We do <strong>not</strong> process payments, store credit card details, or handle
              financial transactions. All payments are settled directly between the cook and the
              buyer.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3">3. How We Use Your Data</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>To connect you with local cooks in your suburb.</li>
            <li>To notify you when a cook approves your order request or sends you a message.</li>
            <li>To keep the platform safe through our Admin moderation team.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3">4. Data Sharing</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>We do <strong>not</strong> sell your personal data.</li>
            <li>
              Your <strong>name</strong> and <strong>suburb</strong> are visible to other users so
              they know who they are talking to.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3">5. Your Choices</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Update or delete your profile at any time from your account settings.</li>
            <li>Revoke push notifications from your device's system settings.</li>
            <li>
              Request full account deletion by emailing{' '}
              <a href="mailto:privacy@eatfromlocal.com" className="text-[#D95A41] underline">
                privacy@eatfromlocal.com
              </a>
              . We will remove your account and personal data within 30 days.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3">6. Contact</h2>
          <p>
            Questions? Email{' '}
            <a href="mailto:privacy@eatfromlocal.com" className="text-[#D95A41] underline">
              privacy@eatfromlocal.com
            </a>
            .
          </p>
        </section>
      </div>

      <div className="mt-12 pt-6 border-t border-[#E5D9C0] text-sm text-neutral-600">
        <Link to="/terms" className="text-[#D95A41] hover:underline" data-testid="privacy-terms-link">
          Terms of Service
        </Link>
      </div>
    </div>
  </div>
);

export default PrivacyPolicyPage;
